
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import LogoutSvg from './svg/LogoutSvg.vue';

export default defineComponent({
  name: 'LogoutIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      LogoutSvg: markRaw(LogoutSvg)
    };
  }
});
